import React, { useContext, useEffect, useState } from "react"

import AddToCartButton from "./Buttons/AddToCartButton"
import ProductCard from "./ProductCard"
import { CartContext } from "../../../cart/store"
import { Color } from "../../../constants/V2/color"
import { useGetStoryblokItem } from "../../../hooks/V2/storyblok/useItem"

import {
  isPurchasableBundle,
  isPurchasableProduct,
  useGetConsolidatedObjectFields,
  useGetPurchasableItem,
} from "@hooks/V2/storyblok"
import { isConsolidatedBundle, isConsolidatedProduct } from "@utils/shop"
type Props = {
  product: Storyblok.Product | Storyblok.Bundle
  openCartPreview?: boolean
}

const RecommendedProduct = ({ product, openCartPreview }: Props) => {
  const getStoryblokItem = useGetStoryblokItem()
  const storyblokItem = getStoryblokItem(product)

  const getConsolidatedObjectFields = useGetConsolidatedObjectFields()
  const consolidatedFields = storyblokItem.content
    ? getConsolidatedObjectFields(storyblokItem.id, storyblokItem.content, 1)
    : undefined

  const getPurchasableProducts = useGetPurchasableItem()
  const purchasableItem = storyblokItem.content
    ? getPurchasableProducts(storyblokItem.id, storyblokItem.content)
    : undefined

  const cartContext = useContext(CartContext)
  const contextProduct = purchasableItem
    ? cartContext.products.find((currentProduct) => {
        if (
          isConsolidatedProduct(currentProduct) &&
          isPurchasableProduct(purchasableItem)
        ) {
          return currentProduct.sku === purchasableItem?.sku
        }
        if (
          isConsolidatedBundle(currentProduct) &&
          isPurchasableBundle(purchasableItem)
        ) {
          return currentProduct.bundleCode === purchasableItem?.bundleCode
        }
      })
    : undefined
  const initialQuantity = contextProduct?.quantity
  const [quantity, setQuantity] = useState(initialQuantity ?? 1)

  useEffect(() => {
    setQuantity(contextProduct?.quantity ?? 1)
  }, [contextProduct?.quantity])

  if (!storyblokItem.content || !purchasableItem) return <p>No Product</p>
  return (
    <div className="flex flex-col gap-8 rounded-12 bg-light-gray px-16 pb-10 md:pr-32">
      <ProductCard
        imageFile={
          typeof consolidatedFields?.image === "string"
            ? consolidatedFields?.image
            : consolidatedFields?.image.filename ||
              storyblokItem.content.image.filename
        }
        imageAlt={
          typeof consolidatedFields?.image !== "string" &&
          consolidatedFields?.image
            ? consolidatedFields?.image.alt
            : storyblokItem.content.image.alt
        }
        productName={consolidatedFields?.name || storyblokItem.content.name}
        description={
          consolidatedFields?.recommendedProductDescription
            ? consolidatedFields?.recommendedProductDescription
            : consolidatedFields?.description?.toString()
        }
        promotionStartDate={consolidatedFields?.promotionStartDate}
        promotionEndDate={consolidatedFields?.promotionEndDate}
        price={consolidatedFields?.price || "0"}
        originalPrice={consolidatedFields?.originalPrice}
        quantity={quantity}
        maxQuantity={
          consolidatedFields?.maxQuantity ||
          // ToDo rework above to ensure consolidatedFields is always defined
          parseInt(process.env.DEFAULT_MAX_PRODUCT_QTY ?? "3")
        }
        onQuantityUpdate={(quantity: number) => setQuantity(quantity)}
        hideQuantityInput={!!consolidatedFields?.reasonNotAvailable}
      >
        {purchasableItem && (
          <AddToCartButton
            size="small"
            fontSize="body-sm-fixed"
            iconSize={12}
            style="bordered"
            className="mt-10 !w-full"
            purchasableItem={purchasableItem}
            quantity={quantity}
            changeCartQuantity={quantity !== contextProduct?.quantity}
            reasonNotAvailable={consolidatedFields?.reasonNotAvailable}
            waitlistLink={consolidatedFields?.waitlistLink}
            overrideTextColor={Color.Black}
            openCartPreview={openCartPreview}
          />
        )}
      </ProductCard>
    </div>
  )
}
export default RecommendedProduct
